import React, { ReactElement, useEffect, useState } from 'react';
import styled from 'styled-components';
import { colorsPalette } from '../../styles/colors-palette';
import { fadeAnimationCss } from '../../styles/GlobalStyle';

type ValidateStatus = '' | 'error' | 'warning';

interface CustomStyles {
  width?: CSSSize | 0;
}
interface ValidationProps {
  message?: string;
  hint?: string;
  validateStatus: ValidateStatus;
  turnValidation?: boolean;
  // control: (status: ValidateStatus) => ReactElement;
  children: ReactElement<{ validateStatus: ValidateStatus; status: ValidateStatus }>;
  disableValidation?: boolean;
  customStyles?: CustomStyles;
}

const ValidationContext = React.createContext<{ validateStatus?: ValidateStatus }>({});

function Validation({
  message,
  hint,
  children,
  validateStatus,
  turnValidation,
  disableValidation,
  customStyles,
}: ValidationProps): ReactElement {
  const [showTouchValidation, setShowTouchValidation] = useState<boolean>(false);
  const [status, setStatus] = useState<ValidateStatus>('');

  useEffect(() => {
    if ((showTouchValidation || turnValidation) && !disableValidation) {
      setStatus(validateStatus);
    } else {
      setStatus('');
    }
  }, [showTouchValidation, validateStatus, disableValidation, turnValidation]);

  return (
    <ValidationContext.Provider value={{ validateStatus: status }}>
      <Wrapper customStyles={customStyles}>
        <span onBlur={() => setShowTouchValidation(true)}>
          {/*{control(status)}*/}
          {children}
          <MessageWrapper>
            {(turnValidation || showTouchValidation) &&
              ['error', 'warning'].includes(status) &&
              !disableValidation && <ErrorMessage status={status}>{message}</ErrorMessage>}
            {hint && !['error', 'warning'].includes(status) && <HelpMessage>{hint}</HelpMessage>}
          </MessageWrapper>
        </span>
      </Wrapper>
    </ValidationContext.Provider>
  );
}

const Wrapper = styled.div<{ customStyles?: CustomStyles }>`
  position: relative;
  display: flex;
  flex-direction: column;
  width: ${props => props.customStyles?.width};
`;

const MessageWrapper = styled.div`
  position: absolute;
`;

const ErrorMessage = styled.p<{ status?: ValidateStatus }>`
  color: ${props => (props.status === 'warning' ? '#faad14' : colorsPalette.red500)};
  font-size: 12px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
    'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
    'Noto Color Emoji';
  margin: 0;
  ${fadeAnimationCss};
`;

const HelpMessage = styled(ErrorMessage)`
  color: ${colorsPalette.gray200};
`;

export { Validation, ValidationContext };
